import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { BREAKPOINT, BreakpointService, FacetComponent, FacetService } from '@spartacus/storefront';
import { ICON_TYPE } from '../../../../../../../custom/icons/icon.model';

import { AuthService, User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Component({
  selector: 'cx-facet',
  templateUrl: './custom-facet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomFacetComponent extends FacetComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  @Input() selected: boolean;
  iconTypes = ICON_TYPE;
  isVisible = false;
  showFacets = false;
  professional = false;
  user$: Observable<User | undefined> = this.userAccount.get();

  constructor(
    protected facetService: FacetService,
    protected elementRef: ElementRef<HTMLElement>,
    protected cd: ChangeDetectorRef,
    private userAccount: UserAccountFacade,
    private auth: AuthService,
    protected breakpointService: BreakpointService,
  ) {
    super(facetService, elementRef, cd);
    this.subscriptions.add(this.user$.subscribe(user => this.professional = user?.professional));
  }

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccount.get();
        } else {
          return of(undefined);
        }
      }),
    );
  }

  toggleGroup(event: UIEvent): void {
    if (!this.selected) {
      this.isVisible = false;
    }
    this.isVisible = !this.isVisible;
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService.isDown(BREAKPOINT.md);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
